module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', [_c('router-link', {
    staticClass: "nav_add",
    attrs: {
      "to": "/add",
      "title": "add vocabulary"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 112 113"
    }
  }, [_c('text', {
    attrs: {
      "x": "-10px",
      "y": "112.08px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav_question",
    attrs: {
      "to": "/",
      "title": "ask me vocabulary"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 102 162"
    }
  }, [_c('text', {
    attrs: {
      "x": "-10px",
      "y": "161.08px"
    }
  }, [_vm._v("?")])])])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66a6dd8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 95
// module chunks = 2